/*
 * usePlanRoutes
 *
 * Purpose:
 * - Own the refetch trigger for the selection.
 * - Load selected routes' waypoints into the RouteStore (via the loader) and
 *   return map-renderable plan routes selected from that store.
 *
 * Why:
 * - Keeps MainComponent slimmer.
 * - The store is the single source of truth for route data (drafts and
 *   persisted routes alike); the selection comes straight from the tree
 *   reducer (no mirror) and alone decides what is drawn.
 */

import { useCallback, useMemo, useState } from "react";
import { useTreeRouteWaypoints } from "@/features/route/hooks/useTreeRouteWaypoints.jsx";
import { useRouteStore } from "@/features/route/state/RouteStore.jsx";
import { selectRenderableRoutes } from "@/features/route/state/index.jsx";

export default function usePlanRoutes({
  selectedRouteIds,
  accessContext,
  setAccessContext,
}) {
  const treeSelectedRouteIds = selectedRouteIds ?? [];
  const [refreshNonce, setRefreshNonce] = useState(0);

  const refetchPlanRoutes = useCallback(() => {
    setRefreshNonce((n) => n + 1);
  }, []);

  useTreeRouteWaypoints({
    selectedRouteIds: treeSelectedRouteIds,
    accessContext,
    setAccessContext,
    refreshNonce,
  });

  const { state: routeStoreState } = useRouteStore();

  const vesselPlanRoutes = useMemo(
    () => selectRenderableRoutes(routeStoreState, treeSelectedRouteIds),
    [routeStoreState, treeSelectedRouteIds],
  );

  return {
    vesselPlanRoutes,
    refetchPlanRoutes,
    refreshNonce,
  };
}
